// constants.ts

export const NAME = 'contentManagement';